// src/tenantAdmin/components/WorkspaceSelector.jsx
//
// Which workspace the Utenti tab acts on. Options are the caller's ADMINISTERED
// workspaces (`adminTenants` — real memberships and the implicit ones a company
// admin holds over its company's workspaces are the same right here), never the
// whole `tenants[]` list: a workspace the user only reads has no user management.
//
// ⛔ Hidden below two options: with one there is nothing to choose, and a
// one-option select reads as a setting the user forgot to make.
//
// ⛔ `disabled` is not decoration. The page passes it while any dialog or confirm
// is open, because the workspace under an open dialog is the workspace its action
// lands in — changing it mid-dialog would apply "remove other@b.com" to a company
// the admin never looked at.
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../auth/AuthContext.jsx';
import { COLORS, FONT_SANS, RADII } from '../../constants/theme.js';

export default function WorkspaceSelector({ value, onChange, disabled = false }) {
  const { t } = useTranslation('admin');
  const { adminTenants } = useAuth();
  // Defensive: any consumer (and every test mock) may omit it.
  const options = adminTenants || [];

  if (options.length < 2) return null;

  return (
    <label style={{
      display: 'inline-flex', alignItems: 'center', gap: '8px',
      fontFamily: FONT_SANS, fontSize: '13px', color: COLORS.textSecondary,
    }}>
      {t('manage.workspaceSelector')}
      <select
        value={value || ''}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        style={{
          height: '40px', padding: '0 12px', borderRadius: RADII.control,
          border: `1px solid ${COLORS.border}`, background: COLORS.surface,
          fontFamily: FONT_SANS, fontSize: '13px', color: COLORS.ink,
          cursor: disabled ? 'not-allowed' : 'pointer',
          opacity: disabled ? 0.6 : 1,
        }}
      >
        {options.map(ws => (
          <option key={ws.tenant_id} value={ws.tenant_id}>
            {ws.display_name || ws.tenant_id}
          </option>
        ))}
      </select>
    </label>
  );
}
